const mEditionSectionContentFooter = {
  mEditionSectionContentFooter: {
    title: 'Todos los derechos reservados'
  }
}

export default mEditionSectionContentFooter
